// import firebase from 'firebase/app'
import * as firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDpjfasBiFKrcbG82JcqigRJRs97qOEckc",
    authDomain: "ttp-project-263f2.firebaseapp.com",
    databaseURL: "https://ttp-project-263f2-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ttp-project-263f2",
    storageBucket: "ttp-project-263f2.appspot.com",
    messagingSenderId: "1078314067887",
    appId: "1:1078314067887:web:63459c2d9af16e3364f15a",
    measurementId: "G-D9TQVCCWDN"
};


firebase.initializeApp(firebaseConfig);
